export default class ChangelogController {
  constructor($sce, $stateParams, ChangelogService, Authorization, UIService) {
    this.$stateParams = $stateParams;
    this.Changelog = ChangelogService;
    this.UI = UIService;
    this.filter = "";
    this.loaded = false;
    this.showAll = $stateParams.expanded;
    this.Authorization = Authorization;
    this.limit = this.showAll ? undefined: 3;
    this.load();
  }

  load = () => {
    this.loaded = false;
    this.Changelog.getVersion(this.$stateParams.version).then((version) => {
      this.version = version;
      this.Changelog.getVersions().then(r => this.versions = r);
      this.loaded = true;
    }).catch(err => {
      //TODO: Handle error
    });
  };

  isSelected = (v) => {
    return (v.version === this.version.version);
  };

  limitTo = () => {
    if (this.filter.length === 0) {
      if (!this.showAll) {
        this.limit = undefined;
        this.showAll = true;
      } else {
        this.limit = 3;
        this.showAll = false;
      }
    }
  };

  isAllowed = () => {
    return this.Authorization.canPerform('changelog');
  };

  filtering = () => {
    if (this.filter.length !== 0) {
      this.showAll = true;
      this.limit = undefined;
    } else {
      this.limitTo();
    }
  };

  getReleaseNote = () => {
    let options = {
      size: 'md',
      template: require('./release.note.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Criar Release Note";
        $scope.version = angular.copy(this.version);
        $scope.versions = angular.copy(this.versions);

        $scope.auxFrom = {
          selected: $scope.version,
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxTo = {
          selected: $scope.versions[$scope.versions.length - 1],
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      if (ok.auxFrom.selected && ok.auxTo.selected) {
        this.Changelog.getReleaseNote(ok.auxFrom.selected.version, ok.auxTo.selected.version).then(url => {
          let downloadLink = angular.element("<a></a>");
          downloadLink.attr("href", url);
          downloadLink.attr("target", '_blank');
          downloadLink.attr("download", "ReleaseNote.pdf");
          console.log(downloadLink);
          downloadLink[0].click();
        }).catch(error => {
          console.log(error);
          this.UI.addToast("Não foi possível obter release note. Verifique a ligação.");
        });
      }
    }).catch(error => {
      console.log(error);
    });
  };
};


ChangelogController.$inject = ['$sce', '$stateParams', 'ChangelogService', 'AuthorizationService', 'UIService'];
